import React from "react";
import { Shield, Home, ArrowLeft, Lock } from "lucide-react";
import "./NoAutorizado.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export const NoAutorizado = () => {
  const navigate = useNavigate();
  const { usuario } = useAuth();

  const onGoHome = () => {
    const permisos = usuario?.permisos || [];

    if (permisos.includes("menu_dashboard")) {
      navigate("/admin/dashboard", { replace: true });
    } else if (permisos.includes("menu_sales")) {
      navigate("/admin/ventas", { replace: true });
    } else if (permisos.includes("menu_reported")) {
      navigate("/admin/reportadas", { replace: true });
    } else if (permisos.includes("menu_recruitment")) {
      navigate("/admin/reclutamiento", { replace: true });
    } else if (permisos.includes("menu_rrhh")) {
      navigate("/admin/rrhh", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  };
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <div className="unauthorized-illustration">
          <div className="shield-container">
            <Shield className="shield-icon" size={80} />
            <Lock className="lock-icon" size={24} />
          </div>
          <div className="floating-elements">
            <div className="floating-dot dot-1"></div>
            <div className="floating-dot dot-2"></div>
            <div className="floating-dot dot-3"></div>
          </div>
        </div>

        <div className="unauthorized-text">
          <h1 className="unauthorized-title">Acceso No Autorizado</h1>
          <p className="unauthorized-description">
            Lo sentimos, no tienes permisos para acceder a esta página. Por
            favor, contacta al administrador del sistema o verifica tus
            credenciales.
          </p>

          <div className="unauthorized-details">
            <div className="detail-item">
              <div className="detail-icon">
                <Shield size={16} />
              </div>
              <span>Área protegida del sistema</span>
            </div>
            <div className="detail-item">
              <div className="detail-icon">
                <Lock size={16} />
              </div>
              <span>Se requieren permisos especiales</span>
            </div>
          </div>
        </div>
        <div className="unauthorized-actions">
          <button className="action-button primary" onClick={onGoHome}>
            <Home size={20} />
            <span>Ir al Dashboard</span>
          </button>
          <button
            className="action-button secondary"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={20} />
            <span>Volver Atrás</span>
          </button>
        </div>
      </div>

      <div className="background-decoration">
        <div className="bg-circle circle-1"></div>
        <div className="bg-circle circle-2"></div>
        <div className="bg-circle circle-3"></div>
      </div>
    </div>
  );
};
